var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-clocked-in"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clocked-in",
    clipPath: "url(#clip-clocked-in)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32863",
    "data-name": "Group 32863",
    transform: "translate(-3398.865 13418.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11156",
    "data-name": "Ellipse 11156",
    transform: "translate(3398.865 -13418.611)",
    fill: "#96a2ea",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "timer_2_",
    "data-name": "timer (2)",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 3418.484, -13411.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34381",
    "data-name": "Path 34381",
    d: "M5.954,5.954a1.328,1.328,0,0,0,0-1.878C5.431,3.553,0,0,0,0S3.544,5.431,4.066,5.954a1.326,1.326,0,0,0,1.887,0Z",
    transform: "matrix(0.956, 0.292, -0.292, 0.956, 3.322, 0.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34382",
    "data-name": "Path 34382",
    d: "M6.541,0l.817,1.3a5.327,5.327,0,1,1-5.34,2.47L1.27,2.689A6.538,6.538,0,1,0,6.555,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockedIn);
export default __webpack_public_path__ + "static/media/clocked-in.48ef34f3cc73ee445e1bfb86ef02d2a4.svg";
export { ForwardRef as ReactComponent };